import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { deleteTutorRequest, updateTutorRequest } from "store/actions";
import CreateTutor from "./CreateTutor";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import TutorDataTable from "components/TableContainers/TutorDataTable";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import Cookies from "js-cookie";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const TutorTable = ({ tutors, loading, totalrows, courses }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [selectedSortData, setSelectedSortData] = useState({
    value: "createdAt",
    direction: "desc",
  });
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");

  const permissions = JSON.parse(localStorage.getItem("permissions"));
  const hasEditPermission = permissions?.some(
    (item) => item?.permission_name === "Edit Tutor"
  );
  const hasDeletePermission = permissions?.some(
    (item) => item?.permission_name === "Delete Tutor"
  );

  const hasViewPermission=permissions?.some(
    (item) => item?.permission_name === "View Tutor"
  );

  console.log("hasViewPermission:",hasViewPermission)


  // Handle deletion
  const handleDeleteConfirmed = (id) => {
    dispatch(deleteTutorRequest(id));
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDeleteConfirmed(deleteId);
    }
  }, [confirmAction]);

  // Table columns
  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
      },
      {
        header: "Email",
        accessorKey: "email",
      },
      {
        header: "Phone",
        accessorKey: "phone",
        showFilter:false
      },
{
  header: "Courses",
  cell: ({ row }) => {
    const courses = row.original?.courses || [];
    if (courses.length === 0) return <span>-</span>;

    const visibleCourses = courses.slice(0, 2).map(c => c.title);
    const remainingCount = courses.length - visibleCourses.length;

    return (
      <span>
        {visibleCourses.join(", ")}
        {remainingCount > 0 && (
          <span style={{ color: "#6c757d", fontStyle: "italic" }}>
            {" "}
            +{remainingCount} more
          </span>
        )}
      </span>
    );
  },
},

      ...(hasEditPermission || hasDeletePermission
        ? [
            {
              header: "Actions",
              id: "actions",
              cell: ({ row }) => {
                const handleEdit = () => {
                  setEditData(row.original);
                  setIsOpen(true);
                };

                const handleDelete = () => {
                  setDeleteId(row.original.id);
                  setOpenModal(true);
                };

                const handleView = () => {
                  navigate(`/tutors/${row.original.id}`); // navigate to Tutor Profile page
                };

                return (
                  <div className="d-flex gap-2">
                    {hasViewPermission && (
                      <Button
                        color="info"
                        onClick={handleView}
                        title="View Profile"
                      >
                        <EyeOutlined />
                      </Button>
                    )}
                    {hasEditPermission && (
                      <Button color="primary" title="Edit" onClick={handleEdit}>
                        <FaRegEdit size={18} />
                      </Button>
                    )}
                    {hasDeletePermission && (
                      <Button
                        color="danger"
                        title="Delete"
                        onClick={handleDelete}
                      >
                        <MdDeleteOutline size={18} />
                      </Button>
                    )}
                  </div>
                );
              },
            },
          ]
        : []),
    ],
    [hasEditPermission, hasDeletePermission]
  );

  const handleFormSubmit = (id, data, onClose) => {
    dispatch(updateTutorRequest(id, data, onClose));
  };

  return (
    <>
      {/* Confirmation Modal */}
      <ConfirmationModal
        okText="Confirm"
        onCancel={() => setOpenModal(false)}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete Tutor"
        content="Are you sure you want to delete this tutor?"
      />

      {/* Edit/Create Modal */}
      <CreateTutor
        visible={isOpen}
        initialData={editData}
        onSubmit={handleFormSubmit}
        handleClose={() => setIsOpen(false)}
        courses={courses}
      />

      {/* Data Table */}
      <div className="container-fluid">
        <TutorDataTable
          columns={columns}
          loading={loading}
          data={tutors || []}
          isGlobalFilter
          isPagination
          selectedSortData={selectedSortData}
          setSelectedSortData={setSelectedSortData}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          pageSize={pageSize}
          setSearchString={setSearchString}
          searchString={searchString}
          SearchPlaceholder="Search tutors..."
          pagination="pagination"
          docName="Tutors"
          totalrows={totalrows}
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
    </>
  );
};

export default TutorTable;
